import { render, staticRenderFns } from "./AItalk3.vue?vue&type=template&id=21fc79b5&"
import script from "./AItalk3.vue?vue&type=script&lang=js&"
export * from "./AItalk3.vue?vue&type=script&lang=js&"
import style0 from "./AItalk3.vue?vue&type=style&index=0&id=21fc79b5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports